import React from 'react';
import cn from 'classnames';
import Text from '@tamagoshi/core/Text';
import { getFooterContext } from '@context';
import { getTranslations } from '@translations';
import { Flags, SocialMedia } from './components';

import styles from './styles/index.module.scss';

const Network = () => {
  const { platform } = getFooterContext();
  const translations = getTranslations();

  return (
    <div className={styles.container}>
      <section className={styles.socialSection}>
        <Text type="body2" weight="semiBold" className={styles.title}>
          <div className={styles.content}>
            {translations('footer.contact.country.title')}
            <Text tag="span" type="small" className={styles.subHeading}>
              {translations('footer.contact.country.sub.title')}
            </Text>
          </div>
          <div className={styles.socialContainer}>
            <Flags platform={platform} />
          </div>
        </Text>
      </section>
      <section className={cn(styles.socialSection, styles.socialMedia)}>
        <Text type="small" weight="semiBold" className={styles.title}>
          <div className={styles.content}>
            {translations('footer.contact.social.network.title')}
            <Text tag="span" type="small" className={styles.subHeading}>
              {translations('footer.contact.social.network.sub.title')}
            </Text>
          </div>
          <div className={styles.socialContainer}>
            <SocialMedia platform={platform} />
          </div>
        </Text>
      </section>
    </div>
  );
};

Network.displayName = 'Network';

export default Network;
